/* eslint-disable @typescript-eslint/no-var-requires */
import { Button, Modal } from 'antd';
import React, { useState } from 'react';
import ImgPoint from '../../../../../assets/animation_point.gif';
import ImgArrowLeft from '../../../../../assets/arrow-left-long.png';
import ImgArrowRight from '../../../../../assets/arrow-right-long.png';
import './component002.less';

interface IComponent002SubItem {
  img: string;
  title: string;
  content: string;
  tip: string;
}

interface IComponent002Item {
  text: string;
  tip?: string;
  subtitle?: string;
  subItems?: IComponent002SubItem[];
}

interface IComponent002Props {
  text: string;
  img?: string;
  icon1?: string;
  icon2?: string;
  title1?: string;
  title2?: string;
  canDoItems: IComponent002Item[];
  cannotDoItems: string[];
  className?: string;
}

const Component002: React.FunctionComponent<IComponent002Props> = ({
  text,
  img,
  icon1,
  icon2,
  title1,
  title2,
  canDoItems,
  cannotDoItems,
  className,
}) => {
  const [isModalOpen, setModalOpen] = useState(false);
  const [currPage, setCurrPage] = React.useState(0);
  const [show, setShow] = useState<number[]>([]);
  const [show1, setShow1] = React.useState<number[]>([]);
  const [show2, setShow2] = React.useState<number[]>([]);
  const setPage = (pagePlus: number) => {
    setCurrPage(currPage + pagePlus);
  };
  const [modalItem, setModalItem] = React.useState<IComponent002SubItem[]>();
  return (
    <>
      <div className={`component002 ${className}`}>
        <div
          className={`component003 position-right ${!text ? 'no-text' : ''}`}
        >
          {text && (
            <>
              <div className="component003-tip">
                <span
                  className="tip-text"
                  dangerouslySetInnerHTML={{ __html: text }}
                />
                <div className="tip-arrow">
                  <div className="line1" />
                  <div className="line2" />
                </div>
                <img
                  src={require(`../../../../../assets/${img}`).default}
                  alt=""
                />
              </div>
            </>
          )}
        </div>
        <div className="cando-section">
          <div className="can-do">
            <div className="cando-img">
              <img
                src={require(`../../../../../assets/${icon1}`).default}
                alt=""
              />
            </div>
            <div className="cando-title" style={{ backgroundColor: '#0CA39A' }}>
              {title1}
            </div>
            <div className="cando-body">
              <div className="cando-content">
                <ul>
                  {canDoItems.map((itm: IComponent002Item, idx: number) => (
                    <li key={idx}>
                      <div className="cando-content-body">
                        {itm.text}
                        {itm.subtitle ? (
                          <span className="view-more">
                            <Button
                              className="view-more-btn"
                              onClick={() => {
                                setModalOpen(true);
                                setModalItem(itm.subItems);
                                setShow([...show, idx]);
                              }}
                              type="link"
                            >
                              {itm.subtitle}
                              <img
                                className="click-point1"
                                hidden={show.includes(idx)}
                                src={ImgPoint}
                                alt=""
                              />
                            </Button>
                          </span>
                        ) : null}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
          <div className="can-not-do">
            <div className="cando-img">
              <img
                src={require(`../../../../../assets/${icon2}`).default}
                alt=""
              />
            </div>
            <div className="cando-title" style={{ backgroundColor: '#E7444E' }}>
              {title2}
            </div>
            <div className="cando-body">
              <div className="cando-content">
                <ul>
                  {cannotDoItems.map((itm: string) => (
                    <li key={itm}>{itm}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modalItem && (
        <Modal
          width="80%"
          className="component002-modal-fsi"
          title={
            <div className="component002-modal-header">
              {modalItem[currPage]?.title}
            </div>
          }
          footer={null}
          open={isModalOpen}
          onCancel={() => {
            setModalOpen(false);
            setCurrPage(0);
          }}
        >
          <div className="border">
            <img
              src={
                require(`../../../../../assets/${modalItem[currPage]?.img}`)
                  .default
              }
              alt=""
            />
          </div>
          {modalItem.length > 0 && modalItem[currPage]?.content && (
            <>
              <div
                className="tip"
                dangerouslySetInnerHTML={{
                  __html: modalItem[currPage]?.tip,
                }}
              />
              <div
                className="content"
                dangerouslySetInnerHTML={{
                  __html: modalItem[currPage]?.content,
                }}
              />
            </>
          )}
          <Button
            className={`prev-button ${currPage === 0 ? 'hide' : ''}`}
            type="text"
            disabled={currPage === 0}
            onClick={() => {
              setPage(-1);
              setShow2([...show2, currPage]);
            }}
          >
            <img className="arrow" src={ImgArrowLeft} alt="" />
            <img
              className="click-point1"
              hidden={!show}
              src={ImgPoint}
              alt=""
            />
          </Button>

          <Button
            className={`next-button ${
              currPage === modalItem.length - 1 ? 'hide' : ''
            }`}
            type="text"
            disabled={currPage === modalItem.length - 1}
            onClick={() => {
              setPage(1);
              setShow1([...show1, currPage]);
            }}
          >
            <img className="arrow" src={ImgArrowRight} alt="" />
            <img
              className="click-point2"
              hidden={show1.includes(currPage)}
              src={ImgPoint}
              alt=""
            />
          </Button>
        </Modal>
      )}
    </>
  );
};
export default Component002;
